<template>

  <section class="banniere-accueil">
    <div class="section" id="HomeSlide">
        <video class="d-none d-md-block" autoplay loop muted>
            <source src="../assets/media/event_background_video.mp4" type="video/mp4">
        </video>
        <img class="d-block d-sm-none" src="../assets/img/event_bg.jpg" alt="" srcset="">
        <div class="overlay">
            <div class="text-center">
                    <h1>Touchez votre cible, <br> vendez encore plus</h1>
                    <btn-commencer/>
            </div>
        </div>
    </div>
  </section>

</template>

<script lang="js">
  import BtnCommencer from '@/components/BtnCommencer.vue'

  export default  {
    name: 'banniere-accueil',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components : {
      BtnCommencer
    }
}
</script>

<style scoped>
</style>
